// DTOs de la bandeja del supervisor: correcciones de paro propuestas por el
// técnico de mantenimiento.
//
//   - GET   /api/supervisor/correcciones-paro?estado=&planta_id=
//   - PATCH /api/supervisor/correcciones-paro/:id/aprobar
//   - PATCH /api/supervisor/correcciones-paro/:id/rechazar
//
// Aprobar = el server aplica el UPDATE al paro (solo los campos propuestos)
// en la misma transacción — auditado por el trigger existente de
// registros_paro; minutos_perdidos es columna GENERATED y se recalcula solo.
// Rechazar exige razón; la corrección liberada permite re-proponer.
import { z } from 'zod';
import { estadoValidacionParoSchema } from './mantenimiento_paros_validacion.js';
const causalRefSchema = z.object({ id: z.string().uuid(), nombre: z.string() });
/** Snapshot ACTUAL del paro al momento de listar (para el diff). */
const paroSnapshotActualSchema = z.object({
    causal_madre: causalRefSchema,
    causal: causalRefSchema,
    hora_inicio: z.string().datetime({ offset: true }),
    hora_fin: z.string().datetime({ offset: true }).nullable(),
    minutos: z.number().nullable(),
});
/** Valores PROPUESTOS (null = ese campo no cambia). */
const paroPropuestoSchema = z.object({
    causal_madre: causalRefSchema.nullable(),
    causal: causalRefSchema.nullable(),
    hora_inicio: z.string().datetime({ offset: true }).nullable(),
    hora_fin: z.string().datetime({ offset: true }).nullable(),
    /** Minutos que quedarían si se aprueba (horas efectivas prop ?? actual). */
    minutos_resultantes: z.number().nullable(),
});
export const correccionParoBandejaItemSchema = z.object({
    id: z.string().uuid(),
    registro_paro_id: z.string().uuid(),
    estado: estadoValidacionParoSchema,
    razon: z.string(),
    created_at: z.string().datetime({ offset: true }),
    tecnico: z.object({ id: z.string().uuid(), nombre: z.string(), apellido: z.string() }),
    lider: z.object({ id: z.string().uuid(), nombre: z.string(), apellido: z.string() }).nullable(),
    linea_id: z.string().uuid(),
    linea_nombre: z.string(),
    planta_id: z.string().uuid(),
    planta_nombre: z.string(),
    /** Fecha operativa del registro padre. */
    fecha: z.string().date(),
    turno_nombre: z.string().nullable(),
    actual: paroSnapshotActualSchema,
    propuesto: paroPropuestoSchema,
    resuelto_por_user_id: z.string().uuid().nullable(),
    resuelto_at: z.string().datetime({ offset: true }).nullable(),
    razon_resolucion: z.string().nullable(),
});
export const correccionesParoBandejaQuerySchema = z.object({
    estado: estadoValidacionParoSchema.default('propuesta'),
    planta_id: z.string().uuid().optional(),
});
export const correccionesParoBandejaResponseSchema = z.object({
    items: correccionParoBandejaItemSchema.array(),
    conteos: z.object({
        propuestas: z.number().int().min(0),
        aprobadas: z.number().int().min(0),
        rechazadas: z.number().int().min(0),
    }),
});
export const correccionParoAprobarSchema = z.object({
    razon_resolucion: z.string().trim().min(10).max(500).optional(),
});
export const correccionParoRechazarSchema = z.object({
    razon_resolucion: z
        .string()
        .trim()
        .min(10, 'Explique el rechazo (mínimo 10 caracteres)')
        .max(500, 'Máximo 500 caracteres'),
});
export const correccionParoResueltaResponseSchema = z.object({
    id: z.string().uuid(),
    estado: estadoValidacionParoSchema,
    resuelto_at: z.string().datetime({ offset: true }),
    /** Presente solo al aprobar: minutos del paro tras aplicar la corrección. */
    minutos_perdidos: z.number().nullable().optional(),
});
//# sourceMappingURL=supervisor_correcciones_paro.js.map